import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { ScoreCardTypeComponent } from './score-card-type/score-card-type.component';
import { ExamMasterComponent } from './exam-master/exam-master.component';
import { ExamScoreCardTypeClassMapComponent } from './exam-score-card-type-class-map/exam-score-card-type-class-map.component';
import { TermComponent } from './term/term.component';
import { ClassTermMapComponent } from './class-term-map/class-term-map.component';
import { ExamClassMapComponent } from './exam-class-map/exam-class-map.component';
import { ExamAchievementScaleComponent } from './exam-achievement-scale/exam-achievement-scale.component';
import { ClassAchievementScaleMapComponent } from './class-achievement-scale-map/class-achievement-scale-map.component';
import { PersonalSkillMasterComponent } from './personal-skill-master/personal-skill-master.component';
import { PersonalSkillActivityComponent } from './personal-skill-activity/personal-skill-activity.component';
import { PerssonalSkillActivityMapComponent } from './perssonal-skill-activity-map/perssonal-skill-activity-map.component';
import { PersonalSkillActivityStaffMapComponent } from './personal-skill-activity-staff-map/personal-skill-activity-staff-map.component';
import { MarksGradingComponent } from './marks-grading/marks-grading.component';
import { GradeScaleComponent } from './grade-scale/grade-scale.component';
import { GradeScaleClassMapComponent } from './grade-scale-class-map/grade-scale-class-map.component';
import { DisciplineMasterComponent } from './discipline-master/discipline-master.component';
import { DisciplineClassMapComponent } from './discipline-class-map/discipline-class-map.component';
import { ExamScheduleSetupComponent } from './exam-schedule-setup/exam-schedule-setup.component';
import { StudentElectiveComponent } from './student-elective/student-elective.component';
import { ExamCoScholasticStudentSetupComponent } from './exam-co-scholastic-student-setup/exam-co-scholastic-student-setup.component';
import { ExamStudentCoScholasticAssessmentComponent } from './exam-student-co-scholastic-assessment/exam-student-co-scholastic-assessment.component';
import { AssessmentFeedbackComponent } from './assessment-feedback/assessment-feedback.component';
import { AssessmentHealthComponent } from './assessment-health/assessment-health.component';
import { AssessmentDisciplineComponent } from './assessment-discipline/assessment-discipline.component';
import { GradedScoreCardComponent } from './graded-score-card/graded-score-card.component';
import { ExamStudentPromotionRemarksComponent } from './exam-student-promotion-remarks/exam-student-promotion-remarks.component';
import { ClassSubjectWiseMarksEntryComponent } from './class-subject-wise-marks-entry/class-subject-wise-marks-entry.component';
import { StudentReportCardComponent } from './report/student-report-card/student-report-card.component';
import { StudentReportCard12Component } from './report/student-report-card12/student-report-card12.component';
import { AdmitCardScheduleComponent } from './admit-card-schedule/admit-card-schedule.component';
import { AdmitCardScheduleSetupComponent } from './admit-card-schedule-setup/admit-card-schedule-setup.component';
import { AdmitCardComponent } from './admit-card/admit-card.component';
import { PrintAdmitCardComponent } from './print-admit-card/print-admit-card.component';
import { ReportcardTerm1Component } from './report/reportcard-term1/reportcard-term1.component';
import { ReportcardTerm2Component } from './report/reportcard-term2/reportcard-term2.component';
import { ReportcardExamWiseComponent } from './report/reportcard-exam-wise/reportcard-exam-wise.component';
import { MppsgReportTerm1Component } from './report/mppsg-report-term1/mppsg-report-term1.component';
import { MppsgReportTerm2Component } from './report/mppsg-report-term2/mppsg-report-term2.component';
import { RpsreportcardComponent } from './report/rpsreportcard/rpsreportcard.component';
import { DepsReportCardComponent } from './report/deps-report-card/deps-report-card.component';
import { TabulationSheetComponent } from './tabulation-sheet/tabulation-sheet.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      { path: 'scorecardtype', component: ScoreCardTypeComponent, pathMatch: 'full' },
      { path: 'exammaster', component: ExamMasterComponent, pathMatch: 'full' },
      { path: 'examscorecardtypeclassmap', component: ExamScoreCardTypeClassMapComponent, pathMatch: 'full' },
      { path: 'term', component: TermComponent, pathMatch: 'full' },
      { path: 'classtermmap', component: ClassTermMapComponent, pathMatch: 'full' },
      { path: 'examclassmap', component: ExamClassMapComponent, pathMatch: 'full' },
      { path: 'examscalemaster', component: ExamAchievementScaleComponent, pathMatch: 'full' },
      { path: 'examclassachievementscalemap', component: ClassAchievementScaleMapComponent, pathMatch: 'full' },
      { path: 'personalskillmaster', component: PersonalSkillMasterComponent, pathMatch: 'full' },
      { path: 'personalskillactivity', component: PersonalSkillActivityComponent, pathMatch: 'full' },
      { path: 'perssonalskillactivitymap', component: PerssonalSkillActivityMapComponent, pathMatch: 'full' },
      { path: 'personalskillactivitystaffmap', component: PersonalSkillActivityStaffMapComponent, pathMatch: 'full' },
      { path: 'gradescale', component: GradeScaleComponent, pathMatch: 'full' },
      { path: 'marksgrading', component: MarksGradingComponent, pathMatch: 'full' },
      { path: 'gradescaleclassmap', component: GradeScaleClassMapComponent, pathMatch: 'full' },
      { path: 'disciplinemaster', component: DisciplineMasterComponent, pathMatch: 'full' },
      { path: 'disciplineclassmap', component: DisciplineClassMapComponent, pathMatch: 'full' },
      { path: 'examschedulesetup', component: ExamScheduleSetupComponent, pathMatch: 'full' },
      { path: 'studentelective', component: StudentElectiveComponent, pathMatch: 'full' },
      { path: 'examcoscholasticstudentsetup', component: ExamCoScholasticStudentSetupComponent, pathMatch: 'full' },
      { path: 'examstudentcoscholasticassessment', component: ExamStudentCoScholasticAssessmentComponent, pathMatch: 'full' },
      { path: 'assessmentfeedback', component: AssessmentFeedbackComponent, pathMatch: 'full' },
      { path: 'assessmenthealth', component: AssessmentHealthComponent, pathMatch: 'full' },
      { path: 'assessmentdiscipline', component: AssessmentDisciplineComponent, pathMatch: 'full' },
      { path: 'gradedscorecard', component: GradedScoreCardComponent, pathMatch: 'full' },
      { path: 'examstudentpromotionremarks', component: ExamStudentPromotionRemarksComponent, pathMatch: 'full' },
      { path: 'classsubjectwisemarksentry', component: ClassSubjectWiseMarksEntryComponent, pathMatch: 'full' },
      { path: 'studentreportcard', component: StudentReportCardComponent, pathMatch: 'full' },
      { path: 'DisciplineClassMapComponent', component: DisciplineClassMapComponent, pathMatch: 'full' },
      { path: 'admitcardschedule', component: AdmitCardScheduleComponent, pathMatch: 'full' },
      { path: 'examsubjectschedulesetup', component: AdmitCardScheduleSetupComponent, pathMatch: 'full' },
      { path: 'examadmitcard', component: AdmitCardComponent, pathMatch: 'full' },
       { path: 'academic-report', component: TabulationSheetComponent, pathMatch: 'full' },


    ]
  },
  {
    path: '',
    children: [
      { path: 'studentreportcard12', component: StudentReportCard12Component, pathMatch: 'full' },
      { path: 'studentreportcardterm1', component: ReportcardTerm1Component, pathMatch: 'full' },
      { path: 'studentreportcardterm2', component: ReportcardTerm2Component, pathMatch: 'full' },
      { path: 'studentreportcardexamwise', component: ReportcardExamWiseComponent, pathMatch: 'full' },
      { path: 'print-admit-card', component: PrintAdmitCardComponent, pathMatch: 'full' },
      { path: 'mppsgreportcardterm1', component: MppsgReportTerm1Component, pathMatch: 'full' },
      { path: 'mppsgreportcardterm2', component: MppsgReportTerm2Component, pathMatch: 'full' },
      { path: 'rpsreportcard', component: RpsreportcardComponent, pathMatch: 'full' },
      { path: 'deps-report-card', component: DepsReportCardComponent, pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExamRoutingModule { }
